import { render, staticRenderFns } from "./DialogListSessions.vue?vue&type=template&id=5ae1602a"
import script from "./DialogListSessions.vue?vue&type=script&lang=js"
export * from "./DialogListSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports